// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}

.admin-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.admin-header h2 {
  margin: 0;
  color: #333;
}

.admin-type-selector {
  display: flex;
  align-items: center;
  gap: 8px;
}

.admin-type-selector select {
  padding: 6px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

.admin-tabs {
  display: flex;
  gap: 8px;
  margin-bottom: 20px;
  border-bottom: 2px solid #eee;
}

.admin-tab {
  padding: 8px 16px;
  background: #f5f5f5;
  border: 1px solid #ddd;
  border-bottom: none;
  border-radius: 4px 4px 0 0;
  cursor: pointer;
  font-size: 14px;
}

.admin-tab.active {
  background: #fff;
  border-color: #1890ff;
  color: #1890ff;
  border-bottom: 2px solid #1890ff;
}

.admin-section {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 16px;
}

.admin-btn-add {
  background: #1890ff;
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 12px;
}

.admin-btn-init {
  background: #52c41a;
  color: #fff;
  border: none;
  padding: 12px 24px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
}

.admin-btn-init:disabled {
  background: #ccc;
  cursor: not-allowed;
}

.admin-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}

.admin-table th {
  background: #f0f0f0;
  padding: 8px;
  text-align: left;
  border: 1px solid #ddd;
}

.admin-table td {
  padding: 6px 8px;
  border: 1px solid #ddd;
}

.admin-table td button {
  padding: 4px 8px;
  margin-right: 4px;
  cursor: pointer;
  font-size: 12px;
  border: 1px solid #ddd;
  border-radius: 3px;
  background: #fff;
}

.admin-table td button:hover {
  background: #f5f5f5;
}

.admin-loading {
  text-align: center;
  padding: 20px;
  color: #999;
}

.admin-error {
  background: #fff2f0;
  border: 1px solid #ffccc7;
  color: #cf1322;
  padding: 10px 16px;
  border-radius: 4px;
  margin-bottom: 16px;
  font-size: 13px;
}

.admin-empty {
  text-align: center;
  padding: 40px;
  color: #999;
}

.admin-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.admin-form label {
  display: flex;
  flex-direction: column;
  font-size: 13px;
  gap: 4px;
}

.admin-form input,
.admin-form select,
.admin-form textarea {
  padding: 6px;
  border: 1px solid #ddd;
  border-radius: 3px;
  font-size: 13px;
}

.admin-form textarea {
  min-width: 300px;
}

.admin-checkbox-group {
  display: flex;
  gap: 12px;
  flex-direction: row;
}

.admin-checkbox {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
}

.admin-form-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.admin-form-actions button {
  padding: 8px 16px;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
}

.admin-form-actions button:first-child {
  background: #1890ff;
  color: #fff;
  border-color: #1890ff;
}

.admin-modal-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(0,0,0,0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.admin-modal {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  width: 500px;
  max-height: 80vh;
  overflow-y: auto;
}

.admin-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.admin-modal-header h3 {
  margin: 0;
}

.admin-modal-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

.admin-tree {
  font-size: 14px;
}

.admin-tree-node {
  padding-left: 20px;
}

.admin-tree-node.l1 {
  padding-left: 0;
  margin-bottom: 8px;
}

.admin-tree-node.l2 {
  padding-left: 20px;
  margin-bottom: 4px;
}

.admin-tree-node.l3 {
  padding-left: 40px;
  color: #666;
  margin-bottom: 2px;
}

.admin-tree-label {
  cursor: pointer;
  padding: 4px;
  border-radius: 3px;
}

.admin-tree-label:hover {
  background: #f0f0f0;
}

.admin-tree-arrow {
  margin-right: 6px;
  font-size: 12px;
}

.admin-tree-info {
  color: #1890ff;
  font-size: 12px;
}

.admin-tree-subtype {
  color: #52c41a;
  font-size: 12px;
}

.admin-tree-ai {
  color: #faad14;
  font-size: 12px;
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/components/AdminPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,QAAQ;AACV;;AAEA;;;EAGE,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,MAAM,EAAE,OAAO,EAAE,QAAQ,EAAE,SAAS;EACpC,2BAA2B;EAC3B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB","sourcesContent":[".admin-page {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n.admin-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.admin-header h2 {\n  margin: 0;\n  color: #333;\n}\n\n.admin-type-selector {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.admin-type-selector select {\n  padding: 6px 12px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 14px;\n}\n\n.admin-tabs {\n  display: flex;\n  gap: 8px;\n  margin-bottom: 20px;\n  border-bottom: 2px solid #eee;\n}\n\n.admin-tab {\n  padding: 8px 16px;\n  background: #f5f5f5;\n  border: 1px solid #ddd;\n  border-bottom: none;\n  border-radius: 4px 4px 0 0;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.admin-tab.active {\n  background: #fff;\n  border-color: #1890ff;\n  color: #1890ff;\n  border-bottom: 2px solid #1890ff;\n}\n\n.admin-section {\n  background: #fff;\n  border: 1px solid #eee;\n  border-radius: 4px;\n  padding: 16px;\n}\n\n.admin-btn-add {\n  background: #1890ff;\n  color: #fff;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-bottom: 12px;\n}\n\n.admin-btn-init {\n  background: #52c41a;\n  color: #fff;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 16px;\n}\n\n.admin-btn-init:disabled {\n  background: #ccc;\n  cursor: not-allowed;\n}\n\n.admin-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 13px;\n}\n\n.admin-table th {\n  background: #f0f0f0;\n  padding: 8px;\n  text-align: left;\n  border: 1px solid #ddd;\n}\n\n.admin-table td {\n  padding: 6px 8px;\n  border: 1px solid #ddd;\n}\n\n.admin-table td button {\n  padding: 4px 8px;\n  margin-right: 4px;\n  cursor: pointer;\n  font-size: 12px;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  background: #fff;\n}\n\n.admin-table td button:hover {\n  background: #f5f5f5;\n}\n\n.admin-loading {\n  text-align: center;\n  padding: 20px;\n  color: #999;\n}\n\n.admin-error {\n  background: #fff2f0;\n  border: 1px solid #ffccc7;\n  color: #cf1322;\n  padding: 10px 16px;\n  border-radius: 4px;\n  margin-bottom: 16px;\n  font-size: 13px;\n}\n\n.admin-empty {\n  text-align: center;\n  padding: 40px;\n  color: #999;\n}\n\n.admin-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.admin-form label {\n  display: flex;\n  flex-direction: column;\n  font-size: 13px;\n  gap: 4px;\n}\n\n.admin-form input,\n.admin-form select,\n.admin-form textarea {\n  padding: 6px;\n  border: 1px solid #ddd;\n  border-radius: 3px;\n  font-size: 13px;\n}\n\n.admin-form textarea {\n  min-width: 300px;\n}\n\n.admin-checkbox-group {\n  display: flex;\n  gap: 12px;\n  flex-direction: row;\n}\n\n.admin-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  font-size: 13px;\n}\n\n.admin-form-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.admin-form-actions button {\n  padding: 8px 16px;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.admin-form-actions button:first-child {\n  background: #1890ff;\n  color: #fff;\n  border-color: #1890ff;\n}\n\n.admin-modal-overlay {\n  position: fixed;\n  top: 0; left: 0; right: 0; bottom: 0;\n  background: rgba(0,0,0,0.4);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.admin-modal {\n  background: #fff;\n  border-radius: 8px;\n  padding: 20px;\n  width: 500px;\n  max-height: 80vh;\n  overflow-y: auto;\n}\n\n.admin-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 16px;\n}\n\n.admin-modal-header h3 {\n  margin: 0;\n}\n\n.admin-modal-close {\n  background: none;\n  border: none;\n  font-size: 24px;\n  cursor: pointer;\n}\n\n.admin-tree {\n  font-size: 14px;\n}\n\n.admin-tree-node {\n  padding-left: 20px;\n}\n\n.admin-tree-node.l1 {\n  padding-left: 0;\n  margin-bottom: 8px;\n}\n\n.admin-tree-node.l2 {\n  padding-left: 20px;\n  margin-bottom: 4px;\n}\n\n.admin-tree-node.l3 {\n  padding-left: 40px;\n  color: #666;\n  margin-bottom: 2px;\n}\n\n.admin-tree-label {\n  cursor: pointer;\n  padding: 4px;\n  border-radius: 3px;\n}\n\n.admin-tree-label:hover {\n  background: #f0f0f0;\n}\n\n.admin-tree-arrow {\n  margin-right: 6px;\n  font-size: 12px;\n}\n\n.admin-tree-info {\n  color: #1890ff;\n  font-size: 12px;\n}\n\n.admin-tree-subtype {\n  color: #52c41a;\n  font-size: 12px;\n}\n\n.admin-tree-ai {\n  color: #faad14;\n  font-size: 12px;\n  font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
